// src/modules/account/data/users.service.js
import api from "../../../services/api";

export async function getMe(options = {}) {
    const { signal } = options;

    const res = await api.get("/api/v1/account/me", {
        signal,
    });

    return res.data;
}

export async function updateMe(attrs = {}, options = {}) {
    const { avatarFile } = options;

    const formData = new FormData();

    if (attrs.name !== undefined) {
        formData.append("user[name]", attrs.name);
    }
    if (attrs.language !== undefined) {
        formData.append("user[language]", attrs.language);
    }
    if (attrs.municipality !== undefined) {
        formData.append("user[municipality]", attrs.municipality);
    }
    if (attrs.country !== undefined) {
        formData.append("user[country]", attrs.country);
    }

    // 👇 nuevos campos normalizados para filtros / joins
    if (attrs.municipality_place_id !== undefined) {
        formData.append(
            "user[municipality_place_id]",
            attrs.municipality_place_id
        );
    }

    if (attrs.municipality_slug !== undefined) {
        formData.append("user[municipality_slug]", attrs.municipality_slug);
    }

    if (attrs.country_code !== undefined) {
        formData.append("user[country_code]", attrs.country_code);
    }

    if (attrs.show_onboarding !== undefined) {
        formData.append("user[show_onboarding]", attrs.show_onboarding);
    }

    if (avatarFile) {
        formData.append("user[avatar]", avatarFile);
    }

    try {
        const res = await api.patch("/api/v1/account/me", formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        return res.data;
    } catch (error) {
        const data = error.response?.data;
        const msg =
            data?.errors?.join(", ") ||
            data?.error ||
            error.message ||
            "Could not update user.";

        const err = new Error(msg);
        err.response = { data };
        throw err;
    }
}

export async function getMyPosts({ page = 1, perPage = 12, signal } = {}) {
    const res = await api.get("/api/v1/account/me/posts", {
        params: { page, per_page: perPage },
        signal,
    });
    return res.data; // { items, pagy }
}

export async function getMyFollowers({ page = 1, items = 20, q, signal } = {}) {
    const res = await api.get("/api/v1/account/me/followers", {
        params: { page, items, q },
        signal,
    });
    return res.data;
}

export async function getMyFollowing({ page = 1, items = 20, q, signal } = {}) {
    const res = await api.get("/api/v1/account/me/following", {
        params: { page, items, q },
        signal,
    });
    return res.data;
}

export async function followUser(userId, { signal } = {}) {
    const { data, status } = await api.post(
        `/api/v1/account/me/following/${userId}`,
        null,
        { signal }
    );
    return { data, status };
}

export async function unfollowUser(userId, { signal } = {}) {
    const { data, status } = await api.delete(
        `/api/v1/account/me/following/${userId}`,
        { signal }
    );
    return { data, status };
}

export async function getUser(id, { signal } = {}) {
    const { data } = await api.get(`/api/v1/users/${id}`, { signal });
    // backend puede devolver { user: ... } o directo
    return data?.user || data;
}

/**
 * Followers de un usuario
 * GET /api/v1/users/:id/followers
 */
export async function getUserFollowers({ userId, page = 1, items = 20, q, signal } = {}) {
    const params = { page, items, ...(q ? { q } : {}) };
    const { data } = await api.get(`/api/v1/users/${userId}/followers`, { params, signal });
    return data;
}

/**
 * Following de un usuario
 * GET /api/v1/users/:id/following
 */
export async function getUserFollowing({ userId, page = 1, items = 20, q, signal } = {}) {
    const params = { page, items, ...(q ? { q } : {}) };
    const { data } = await api.get(`/api/v1/users/${userId}/following`, { params, signal });
    return data;
}

/**
 * Posts de un usuario
 * GET /api/v1/users/:id/posts
 */
export async function getUserPosts({ userId, page = 1, items = 20, q, signal } = {}) {
    const params = { page, items, ...(q ? { q } : {}) };
    const { data } = await api.get(`/api/v1/users/${userId}/posts`, { params, signal });
    return data;
}

export async function getUserPets({ userId, page = 1, items = 20, q, signal } = {}) {
    const params = { page, items, ...(q ? { q } : {}) };
    const { data } = await api.get(`/api/v1/users/${userId}/pets`, { params, signal });
    return data;
}